import Vue from 'vue'
/**
 * Usage:
 *
 * In template:
 * <div v-draggable></div>
 *
 */
Vue.directive('draggable', {
  bind(el) {
    el.offsetX = 0
    el.offsetY = 0

    const move = function(e) {
      el.style.marginLeft = '0px'
      el.style.marginTop = '0px'
      el.style.left = e.pageX - el.offsetX + 'px'
      el.style.top = e.pageY - el.offsetY + 'px'
    }

    const up = function() {
      removeEventListener('mousemove', move)
      removeEventListener('mouseup', up)
    }

    const down = function(e) {
      el.offsetX = e.pageX - el.offsetLeft
      el.offsetY = e.pageY - el.offsetTop

      addEventListener('mousemove', move)
      addEventListener('mouseup', up)

      event.preventDefault()
      event.stopPropagation()
    }

    el.addEventListener('mousedown', down)
  }
})
